import { atom } from 'jotai';

/** DOM id on the details section beside the picture: the statement's Read more lands here. */
export const PRODUCT_DETAILS_SECTION_ID = 'product-details';

/**
 * Whether the column beside the picture is open in full — the description
 * past its crop and every row of the list. An atom because the control that
 * opens it most is not in that column: it is the statement's Read more at the
 * top of the page, which sends the reader down to it.
 */
export const productDetailsExpandedAtom = atom(false);
